import { render, staticRenderFns } from "./DocumentPageMenu.vue?vue&type=template&id=23ef151e&scoped=true&"
import script from "./DocumentPageMenu.vue?vue&type=script&lang=ts&"
export * from "./DocumentPageMenu.vue?vue&type=script&lang=ts&"
import style0 from "./DocumentPageMenu.vue?vue&type=style&index=0&id=23ef151e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ef151e",
  null
  
)

export default component.exports